import { registerBlockType } from "@wordpress/blocks";
import config, { type BlockAttributes } from "./block.json";
import "../slider/swiper";
import TeaserSave from "./TeaserSave";
import TeaserEditor from "./TeaserEditor";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: TeaserEditor,
  save: TeaserSave,
});
